import { Link } from 'react-router-dom'
import { Grid, GridColumn, GridPageChangeEvent } from '@progress/kendo-react-grid'
import './Programs.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons'
import { useEffect, useState } from 'react'
import { ProgramasService } from '../../services/programas.service'
import { Programa } from '../../models/programas.model'
import Loading from '../shared/loading/Loading.component'
interface PageState {
    skip: number;
    take: number;
}
const initialDataState: PageState = { skip: 0, take: 10 };

export const Programs = () => {
    const programasService = ProgramasService({ locale: 'en' });
    const [page, setPage] = useState<PageState>(initialDataState);
    const [programas, setProgramas] = useState<Programa[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    useEffect(() => {
        function getProgramas() {
            setLoading(true)
            programasService.getProgramas().then(responsePrograma => {
                setProgramas(responsePrograma.data)
                setLoading(false)
            });
        }
        getProgramas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const pageChange = (event: GridPageChangeEvent) => {
        setPage(event.page);
    };
    function editCountry(props: any) {
        const { oid } = props.dataItem
        return (
            <td>
                <Link to={`/admin-users/programs/${oid}`}>
                    <FontAwesomeIcon className='editIcon' icon={faPenToSquare}></FontAwesomeIcon>
                </Link>
            </td>
        )
    }
    return (
        <>
            {loading ? (
                <div className="loading-comp">
                    <Loading />
                </div>
            ) : (
                <div className='first--program--cont'>
                    <div className='program--grid--container'>
                        <div className='grid--container'>
                            <p>Programas</p>
                            <Grid data={programas.slice(page.skip, page.take + page.skip)} scrollable='none'
                                skip={page.skip}
                                take={page.take}
                                total={programas.length}
                                pageable={true}
                                onPageChange={pageChange}>
                                <GridColumn field="oid" title="ID" />
                                <GridColumn field="nombre" title="Nombre" />
                                <GridColumn field="descripcion" title="Programa" />
                                <GridColumn cell={editCountry} title="Acción" />
                            </Grid>
                            <div className='buttons-cont-grid'>
                                <Link className="link--to--country" to="/admin-users">
                                    <button className="btn-back">Volver</button>
                                </Link >
                                <Link className="link--to--country" to="/admin-users/programs/create">
                                    <button className="btn-create">Crear Programa</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </>
    )
}
